import { pipe, ifElse, identity } from 'ramda'
import { appendString, isFalsy } from '@v/util/briqRamdaExt.js'

export function convertTo24HourString({ hh, mm, A }) {
  // Note: 12 AM is 00:00, and 12 PM is 12:00
  const hour = parseInt(hh) === 12 ? '00' : hh
  const HH = A === 'PM' ? (parseInt(hour) + 12).toString() : hour
  return parseTimeString({ HH, mm })
}

export function parseTimeString({ HH, mm }) {
  return !HH || !mm ? null : `${HH}:${mm}`
}

export const shouldEmit = twelveHourClock => ({ hh, mm, A, HH }) => {
  // either all parts must be present or none of them
  if (twelveHourClock) {
    if (hh && mm && A) return true
    if (!hh && !mm && !A) return true
  } else {
    if (HH && mm) return true
    if (!HH && !mm) return true
  }
  return false
}

export const getEmitValue = (twelveHourClock, appendSeconds) =>
  ifElse(
    isFalsy,
    () => null,
    pipe(
      ifElse(() => twelveHourClock, convertTo24HourString, parseTimeString),
      ifElse(() => appendSeconds, appendString(':00'), identity),
    ),
  )

function convertHours(hours) {
  if (hours === 0) return '12'
  const hh = hours > 12 ? hours - 12 : hours
  return hh.toString().padStart(2, '0')
}

export function convertTo12HourObject(timeString) {
  const splits = timeString.split(':')
  const HH = parseInt(splits[0])
  const hh = convertHours(HH)
  const mm = splits[1]
  // Note: 00:00 is 12 AM, and 12:00 is 12 PM
  const A = HH >= 12 ? 'PM' : 'AM'
  return { hh, mm, A }
}
